function changeTheme(themeName = "default") {
 //console.log("theme" ,themeName)
  document.documentElement.setAttribute("data-theme", themeName);
}

export default changeTheme;
